import OadpContainer from './oadp-container';
export default OadpContainer;
